import {useSelector, shallowEqual} from 'react-redux';
import {
  useAutoFocus as useSharedAutoFocus,
  useNavigationFocus as useSharedNavigationFocus,
} from '../../../hooks/useAutoFocus';
import {setMainInputFocus} from '../../../actions/ScanToCartScanningActions';

const selectFocusState = (state) => ({
  mainInputHasFocus: state.scanToCartScanning.mainInputHasFocus,
  promptVisible: state.scanToCartScanning.prompt.isVisible,
  isNotEmptyCart: state.scanToCartScanning.isNotEmptyCart,
  showCartAssignmentDetailsPrompt:
    state.scanToCart.showCartAssignmentDetailsPrompt,
  currentCartScanComplete: state.scanToCart.currentCartScanComplete.isVisible,
  placedItemConfirmation: state.scanToCartScanning.placedItemConfirmation,
  scanSuccess: state.scanToCartScanning.scanSuccess,
  scanError: state.scanToCartScanning.scanError,
  showOutOfStockPrompt: state.scanToCart.showOutOfStockPrompt,
});

const useAutoFocus = (delay = 3000) => {
  const {
    mainInputHasFocus,
    promptVisible,
    isNotEmptyCart,
    showCartAssignmentDetailsPrompt,
    currentCartScanComplete,
    placedItemConfirmation,
    scanSuccess,
    scanError,
    showOutOfStockPrompt,
  } = useSelector(selectFocusState, shallowEqual);

  const isAnyPromptOpen =
    promptVisible ||
    isNotEmptyCart ||
    showCartAssignmentDetailsPrompt ||
    currentCartScanComplete ||
    placedItemConfirmation ||
    scanSuccess ||
    scanError ||
    showOutOfStockPrompt;

  return useSharedAutoFocus({
    mainInputHasFocus,
    isAnyPromptOpen,
    setFocusAction: setMainInputFocus,
    delay,
  });
};

export const useNavigationFocus = () =>
  useSharedNavigationFocus(setMainInputFocus);

export default useAutoFocus;
